/**
 * Identity
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SearchUserRoleResponse } from './search-user-role-response';
import { SearchUserStatusResponse } from './search-user-status-response';


export interface SearchUsersResponseItem { 
    id?: string;
    mainAccountId?: string;
    login?: string | null;
    email?: string | null;
    phoneNumber?: string | null;
    roles?: Array<SearchUserRoleResponse> | null;
    status?: SearchUserStatusResponse;
    lockoutEndDate?: string | null;
    lastLoginDate?: string | null;
    blockedDate?: string | null;
    blockReason?: string | null;
    blockedByAdmin?: string | null;
    isAuthenticatorEnabled?: boolean;
}

